
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7025_9518)","fill":"#000C1F"}},[_c('path',{attrs:{"d":"M12.888 1.96l.847.299.282.846a.334.334 0 00.633 0l.281-.842.842-.28a.333.333 0 000-.633l-.842-.28-.28-.843c-.092-.272-.542-.272-.633 0l-.28.838-.837.262a.333.333 0 00-.013.632zM15.791 12.69l-1.772-.708-.709-1.772c-.1-.254-.518-.254-.618 0l-.708 1.768-1.768.669a.334.334 0 00-.011.618l1.777.75.71 1.774a.332.332 0 00.618 0l.709-1.771 1.772-.71a.333.333 0 000-.618zm-2.153.762a.332.332 0 00-.185.186L13 14.768l-.452-1.13a.33.33 0 00-.18-.183l-1.137-.48 1.125-.425a.334.334 0 00.192-.189l.452-1.13.453 1.13c.034.085.1.152.185.186L14.77 13l-1.13.452zM12.623 8.307c.432-.138.71-.52.71-.973 0-.453-.278-.835-.718-.975L8.771 5.23 7.652 1.39A1.006 1.006 0 006.69.668c-.444.019-.838.268-.986.709L4.563 5.23.723 6.35C.29 6.48.006 6.86 0 7.312a1.01 1.01 0 00.709.986l3.854 1.139 1.131 3.853c.138.432.52.71.973.71.452 0 .834-.278.975-.718L8.771 9.44l3.844-1.128.008-.003v-.001zm-.2-.636L8.41 8.849a.333.333 0 00-.226.226l-1.178 4.012a.345.345 0 01-.338.247.341.341 0 01-.335-.239l-1.18-4.019a.333.333 0 00-.225-.226L.91 7.663a.344.344 0 01-.242-.342c0-.06.021-.264.247-.333l4.012-1.169a.332.332 0 00.226-.225l1.188-4.017a.343.343 0 01.336-.242h.004c.061.001.265.022.334.248l1.168 4.01c.032.11.117.195.226.227l4.012 1.177c.23.074.247.278.247.338 0 .061-.017.263-.243.337l-.002-.001z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7025_9518"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    